import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler,
    Text,
    TouchableWithoutFeedback,
    ScrollView
} from "react-native";

import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
// import {
//     serviceActionAddSubList,
//     serviceActionListFilter,
//     serviceActionSuccess,
//     serviceActionError,
//     serviceActionSetLike,
//     serviceActionSetDisplayImage,
//     serviceActionSetDisplayComment,
//     serviceActionSetComment, serviceActionAddFile
// } from "./action/ActionGalleryServiceScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";

import HMIcon from "../../../../customviews/HMIcon";
import HMModalSearch from "../../../../customviews/HMModalSearch";
import HMSwiper from "../../../../customviews/swiper/HMSwiper";
import HMImageView from "../../../../customviews/HMImageView";
import {Image} from "../../../../customviews/HMListCheckBox";
import HMModal from "../../../../customviews/modal/HMModal";
import ImagePicker from "react-native-image-crop-picker";

import axios from "axios";
import HMAlert from "../../../../customviews/HMAlert";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";

let container = null;
import {connect} from "react-redux";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {serviceActionSetToken} from "../../splash/action/ActionSplashGetAllData";
import {Tools} from "../../../../tools/Tools";
import importFirebase from "../../../../importCalss/firebase/importFirebase";
import * as NavigationService from "../../../../redux/NavigationService";


let firebase = importFirebase;

class DetailsGalleryServiceOperationScreen extends Component {
    constructor(props) {
        super(props);
        //  global._refreshListOpertor = true;


        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 1000 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }
        this.state = {


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,


            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,
            showModal: false,
            results: null,
            list: [
                {
                    id: 1,
                    like: false,
                    files: [
                        {
                            id: 1,
                            image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
                            display: false
                        },
                        {
                            id: 2,
                            image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
                            display: true
                        },
                        {
                            id: 3,
                            image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
                            display: true
                        },
                    ],
                    lastWork: [
                        {
                            id: 10,
                            title: "شهروند",
                            comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
                            display: false
                        },
                        {
                            id: 11,
                            title: "137 منطقه",
                            comment: "بازرسی شد و گفته شهروند صحیح است",
                            display: true
                        },
                        {
                            id: 12,
                            title: "مجری",
                            comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
                            display: false
                        },
                        {
                            id: 13,
                            title: "رضایت مندی",
                            comment: "شهروند از عملیات رضایت ندارد",
                            display: true
                        },
                        {
                            id: 14,
                            title: "بازرسی",
                            comment: "عملیات مجری مورد تایید است",
                            display: true
                        },
                    ]
                },
                {
                    id: 2,
                    like: true,
                    files: [
                        {
                            id: 1,
                            image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
                            display: true
                        },
                        {
                            id: 2,
                            image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
                            display: true
                        },
                        {
                            id: 3,
                            image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
                            display: true
                        },
                    ],
                    lastWork: [
                        {
                            id: 10,
                            title: "شهروند",
                            comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
                            display: true
                        },
                        {
                            id: 11,
                            title: "137 منطقه",
                            comment: "بازرسی شد و گفته شهروند صحیح است",
                            display: true
                        },
                        {
                            id: 12,
                            title: "مجری",
                            comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
                            display: true
                        },
                        {
                            id: 13,
                            title: "رضایت مندی",
                            comment: "شهروند از عملیات رضایت ندارد",
                            display: true
                        },
                        {
                            id: 14,
                            title: "بازرسی",
                            comment: "عملیات مجری مورد تایید است",
                            display: true
                        },
                    ]
                },
            ]

        };
        container = this;

        //
        // this.props.navigation.addListener('focus', () => {
        //         if (global._refreshListOpertor) {
        //             store.dispatch(serviceActionListFilter([]))
        //             props.callserviceActionRefresh();
        //             this.getData(1)
        //             global._refreshListOpertor = false
        //         }
        //
        //     }
        // )
        // )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {


        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {


                }
            )
            :
            null
    }


    async componentDidMount() {
        if (!this.props.token) {

            let token = await AsyngStorageClass.checkToken();
            store.dispatch(serviceActionSetToken(token));
        }

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                )


            })

        // store.dispatch(serviceActionListFilter([]))
        // this.props.callserviceActionRefresh();


        // let token = await AsyngStorageClass.checkToken();
        //
        // store.dispatch(serviceActionSetToken(token));

        this.getData()


    }


    componentWillUnmount() {

    }


    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {item, data} = this.props.route && this.props.route.params ? this.props.route.params : {};
        let checkHeader = this.props.route && this.props.route.params && this.props.route.params.header;
        let {results} = this.state;

        // let childFilter = result.items[this.state.indexFilter].list;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        let heightSlider = (this.state.viewportWidth > 600) ? 500 : (Platform.OS === "web" ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        {
                            checkHeader ?

                                null
                                :
                                <HMActionBar
                                    // menu
                                    props={this.props} statusBarTransparent
                                    // text={i18n.t('ListOperatorApply.title')}
                                    //text={i18n.t('ListNews.title')}
                                    text={data ? (data.name ? data.name : (data.title ? data.title : '')) : "آلبوم خدمت"}
                                    //  text={this.state.arraySelected.length}

                                    back={data}
                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                        }

                        <View style={{flex: 1}}>
                            <ScrollView>
                                {
                                    results ?
                                        <View
                                            style={{
                                                flex: 1,
                                                marginVertical: moderateScale(10),
                                                marginHorizontal: moderateScale(10),
                                                borderRadius: moderateScale(10),
                                                overflow: 'hidden'

                                                // alignItems: 'center'
                                            }}>

                                            <View
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: Colors.white,
                                                }}>
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        // height: this.state.viewportWidth / 1.6,
                                                        height: heightSlider,
                                                        //marginTop:moderateScale(6),
                                                        // backgroundColor:"#2bee8f"
                                                    }}
                                                    /*      onPress={() => {
                                                              //alert("fghf")
                                                              if (container.state.backClickCount === 1) {
                                                                  //  alert(" " + container.state.backClickCount)
                                                                  container.setState({backClickCount: 0});
                                                                  container.setLike(item, index);


                                                              } else {
                                                                  container.setState({backClickCount: 1}, () => {

                                                                          setTimeout(function () {
                                                                              container.setState({backClickCount: 0},
                                                                                  () => {

                                                                                      // onPressLike()
                                                                                      // alert("  " + container.state.backClickCount)
                                                                                  });

                                                                          }, 300)

                                                                      }
                                                                  )
                                                              }

                                                          }}*/

                                                >
                                                    {
                                                        results.slider && results.slider.length > 0 ?
                                                            <HMSwiper
                                                                list={results.slider}
                                                                notLoop
                                                                notClick
                                                                notAutoPlay
                                                                renderItem={() => {
                                                                    return results.slider.map((itemSwiper, indexSwiper) => {
                                                                        return <DynamicContentSlide
                                                                            itemSwiper={itemSwiper}
                                                                            indexSwiper={indexSwiper}
                                                                            // onPressLike={() => {
                                                                            //     if (container.state.backClickCount === 1) {
                                                                            //         //  alert(" " + container.state.backClickCount)
                                                                            //         container.setState({backClickCount: 0});
                                                                            //         container.setLike(item, index);
                                                                            //
                                                                            //
                                                                            //     } else {
                                                                            //         container.setState({backClickCount: 1}, () => {
                                                                            //
                                                                            //                 setTimeout(function () {
                                                                            //                     container.setState({backClickCount: 0},
                                                                            //                         () => {
                                                                            //
                                                                            //                             // onPressLike()
                                                                            //                             // alert("  " + container.state.backClickCount)
                                                                            //                         });
                                                                            //
                                                                            //                 }, 300)
                                                                            //
                                                                            //             }
                                                                            //         )
                                                                            //     }
                                                                            // }}

                                                                            // onPress={() => {
                                                                            //
                                                                            //     const formData = new FormData();
                                                                            //     formData.append('lang', i18n.locale);
                                                                            //     formData.append('record', item.id);
                                                                            //     formData.append('recordChild', itemSwiper.id);
                                                                            //     formData.append('_session', container.props.token);
                                                                            //     formData.append('_operation', typeExport._Shahrdar);
                                                                            //     // // formData.append('lang', params.lang);
                                                                            //     formData.append('mode', "SetLikeFile");
                                                                            //
                                                                            //     this.setData(() => {
                                                                            //         store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                            //     }, formData)
                                                                            //
                                                                            //
                                                                            // }}
                                                                        />

                                                                    })
                                                                }}

                                                            />
                                                            :
                                                            <View
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    backgroundColor: Colors.gray,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                <HMIcon
                                                                    type={"FontAwesome"}
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"picture-o"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(48)}, {
                                                                        color: Colors.white
                                                                    }]}/>
                                                            </View>

                                                    }
                                                    <TouchableOpacity
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: moderateScale(22),
                                                            right: moderateScale(10),
                                                            // width: moderateScale(50),
                                                            height: moderateScale(34),
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            borderRadius: moderateScale(8),
                                                            backgroundColor: Colors.white,
                                                            borderWidth: moderateScale(1),
                                                            borderColor: Colors.colorPrimary,
                                                            //    padding:moderateScale(14)


                                                        }}
                                                        onPress={() => {
                                                            NavigationService.navigateParams(checkHeader ? "DetailsOperatorApplyScreen_Root" : "DetailsOperatorApplyScreen", {item: results})

                                                        }}
                                                    >
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={results.messageno}
                                                            type={"bold"}
                                                            style={{
                                                                textAlign: "center",
                                                                color: Colors.colorDarkText,
                                                                fontSize: moderateScale(14),
                                                                marginHorizontal: moderateScale(8)

                                                            }}/>
                                                    </TouchableOpacity>
                                                </View>

                                                <View
                                                    style={{
                                                        flex: 1,
                                                        flexDirection: 'row',
                                                        paddingHorizontal: moderateScale(10),
                                                        alignItems: 'center',
                                                        marginTop: moderateScale(4)
                                                    }}>
                                                    <TouchableOpacity style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',


                                                    }}
                                                        // onPress={() => {
                                                        //     this.setLike(item, index)
                                                        // }}

                                                    >
                                                        <HMIcon
                                                            type={"FontAwesome"}
                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                            name={results.like ? "send" : "send-o"}
                                                            //resizeMode="stretch"
                                                            style={[{fontSize: moderateScale(30)}, results.like ? {
                                                                color: "#ee0003"
                                                            } : {
                                                                color: "#6f6f6f"
                                                            }]}/>

                                                    </TouchableOpacity>
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            if (Platform.OS === "web" && !navigator.share) {
                                                                // alert(typeExport._Url137 + "details_gallery_operation/" + item.id)
                                                                alert(results.sharing)

                                                            }
                                                            else
                                                                Tools.onShare({
                                                                    // link_url: typeExport._Url137 + "details_gallery_operation/" + item.id,
                                                                    link_url: results.sharing,
                                                                    description: "این پست را دوست شما برای شما فرستاده لطفا مشاهد نمایید"
                                                                });


                                                        }}
                                                        style={{
                                                            width: moderateScale(30),
                                                            height: moderateScale(30),
                                                            alignItems: 'center', justifyContent: 'center',
                                                            marginHorizontal: moderateScale(12),
                                                            //  backgroundColor:"#72ee3b"

                                                        }}>
                                                        <HMIcon
                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                            name={"ios-share-social-outline"}
                                                            //resizeMode="stretch"
                                                            style={[{fontSize: moderateScale(30)}, {
                                                                color: Colors.colorDarkText,
                                                            }]}/>

                                                    </TouchableOpacity>

                                                    {/*     <TouchableOpacity
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',
                                                        borderWidth: moderateScale(2),
                                                        borderColor: Colors.colorDarkText,
                                                        marginHorizontal: moderateScale(14)


                                                    }}
                                                    onPress={() => {

                                                        this.setState({
                                                            showModal: "selectImage",
                                                            index: index,
                                                            item: item,

                                                        })
                                                    }}
                                                >
                                                    <HMIcon
                                                        type={"FontAwesome"}
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"plus"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(20)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>

                                                </TouchableOpacity>*/}
                                                    {/*   <TouchableOpacity style={{
                                                    width: moderateScale(30),
                                                    height: moderateScale(30),
                                                    alignItems: 'center', justifyContent: 'center',


                                                }}>
                                                    <HMIcon
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"ios-share-social-outline"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>

                                                </TouchableOpacity>*/}

                                                    {/*   <TouchableOpacity
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',


                                                    }}
                                                    onPress={() => {
                                                        this.setState({
                                                            showModal: "addComment",
                                                            comment: null,

                                                            index: index,
                                                            item: item,
                                                        })

                                                    }}
                                                >
                                                    <HMIcon
                                                        type={"FontAwesome"}

                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"comment-o"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>

                                                </TouchableOpacity>*/}
                                                    <View style={{flex: 1}}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={results.createdtime}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(13),
                                                            marginHorizontal: moderateScale(2)

                                                        }}/>
                                                </View>
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        flex: 1,
                                                        //  width:'100%',
                                                        //   justifyContent: "flex-end",
                                                        // flexWrap: 'wrap',
                                                        marginHorizontal: moderateScale(12),
                                                        marginVertical: moderateScale(6),

                                                    }}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={"موضوع" + " : "}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(14)

                                                        }}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={results.title}
                                                        type={"bold"}
                                                        style={{
                                                            //  textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(14)

                                                        }}
                                                        styleRoot={{
                                                            flexDirection: 'column',
                                                            flex: 1,
                                                            // justifyContent: "flex-end",
                                                            flexWrap: 'wrap',
                                                            //    alignItems: 'center', justifyContent: 'center'
                                                        }}
                                                    />
                                                </View>
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        flex: 1,
                                                        //  width:'100%',
                                                        //   justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        marginHorizontal: moderateScale(12),
                                                        marginVertical: moderateScale(6),

                                                    }}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={"آدرس" + " : "}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(14)

                                                        }}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.address}
                                                        type={"bold"}
                                                        style={{
                                                            //  textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(14)

                                                        }}
                                                        styleRoot={{
                                                            flexDirection: 'row',
                                                            flex: 1,
                                                            // justifyContent: "flex-end",
                                                            flexWrap: 'wrap',
                                                            //    alignItems: 'center', justifyContent: 'center'
                                                        }}
                                                    />
                                                </View>
                                                <View style={{marginBottom: moderateScale(8)}}>
                                                    {
                                                        results.lastWork ?
                                                            results.lastWork.map((itemWork, indexWork) => {
                                                                return <View
                                                                    style={{
                                                                        flex: 1,
                                                                        flexDirection: 'row',
                                                                        alignItems: 'center',
                                                                        marginHorizontal: moderateScale(12),
                                                                        marginVertical: moderateScale(5),
                                                                        borderWidth: moderateScale(.7),
                                                                        borderRadius: moderateScale(2),

                                                                        borderColor: '#ddd',
                                                                        borderBottomWidth: moderateScale(.7),
                                                                        shadowColor: '#000',
                                                                        shadowOffset: {
                                                                            width: 0,
                                                                            height: moderateScale(.7)
                                                                        },
                                                                        shadowOpacity: 0.6,
                                                                        shadowRadius: moderateScale(2),
                                                                        elevation: moderateScale(1),

                                                                        // borderRadius: moderateScale(8),
                                                                        margin: moderateScale(8),
                                                                        padding: moderateScale(10),
                                                                        // backgroundColor:"#F2F2F2"
                                                                    }}>
                                                                    <TouchableOpacity
                                                                        style={{
                                                                            width: moderateScale(28),
                                                                            height: moderateScale(28),
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                        }}
                                                                        // onPress={() => {
                                                                        //     const formData = new FormData();
                                                                        //     formData.append('lang', i18n.locale);
                                                                        //     formData.append('record', item.id);
                                                                        //     formData.append('recordChild', itemWork.id);
                                                                        //     formData.append('_session', container.props.token);
                                                                        //     formData.append('_operation', typeExport._Shahrdar);
                                                                        //     // // formData.append('lang', params.lang);
                                                                        //     formData.append('mode', "SetLikeComment");
                                                                        //
                                                                        //     this.setData(() => {
                                                                        //         store.dispatch(serviceActionSetDisplayComment(!itemWork.display, index, indexWork))
                                                                        //     }, formData)
                                                                        //     // const some_array = [...this.state.list]
                                                                        //     //
                                                                        //     // some_array[index].lastWork[indexWork].display = !this.state.list[index].lastWork[indexWork].display
                                                                        //     //
                                                                        //     // this.setState({list: some_array}
                                                                        //     //     ,
                                                                        //     //     () => {
                                                                        //     //     }
                                                                        //     // )
                                                                        // }}

                                                                    >
                                                                        <HMIcon
                                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                            name={itemWork.display ? "md-eye" : "eye-off"}
                                                                            //resizeMode="stretch"
                                                                            style={[{fontSize: moderateScale(28)},
                                                                                {
                                                                                    color: Colors.colorSecondPrimary
                                                                                }
                                                                            ]}/>

                                                                    </TouchableOpacity>
                                                                    {/*         <TouchableOpacity
                                                                    style={{
                                                                    width: moderateScale(26),
                                                                    height: moderateScale(26),
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    marginHorizontal: moderateScale(8)


                                                                }}
                                                                                  onPress={() => {
                                                                                      this.setState({
                                                                                          showModal: true,
                                                                                          comment: itemWork.comment,

                                                                                          index: index,
                                                                                          indexWork: indexWork,
                                                                                          item: item,
                                                                                          itemWork: itemWork,
                                                                                      })

                                                                                  }}
                                                                >
                                                                    <HMIcon
                                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                        name={"pencil-sharp"}
                                                                        //resizeMode="stretch"
                                                                        style={[{fontSize: moderateScale(24)}, {
                                                                            color: "#6f6f6f"
                                                                        }]}/>

                                                                </TouchableOpacity>*/}


                                                                    <View style={{
                                                                        flexDirection: "row",
                                                                        flex: 1,
                                                                        //  width:'100%',
                                                                        //   justifyContent: "flex-end",
                                                                        flexWrap: 'wrap',

                                                                    }}>
                                                                        <HMTextView
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={itemWork.title + " : "}
                                                                            type={"bold"}
                                                                            style={{
                                                                                textAlign: "center",
                                                                                color: Colors.blackLight,
                                                                                fontSize: moderateScale(14)

                                                                            }}/>
                                                                        <HMTextView
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={itemWork.comment}
                                                                            type={"bold"}
                                                                            style={{
                                                                                //  textAlign: "center",
                                                                                color: Colors.colorDark,
                                                                                fontSize: moderateScale(14)

                                                                            }}
                                                                            styleRoot={{
                                                                                flexDirection: 'column',
                                                                                flex: 1,
                                                                                // justifyContent: "flex-end",
                                                                                flexWrap: 'wrap',
                                                                                //    alignItems: 'center', justifyContent: 'center'
                                                                            }}

                                                                        />
                                                                    </View>
                                                                </View>
                                                            })
                                                            :
                                                            null
                                                    }


                                                </View>

                                            </View>

                                        </View>
                                        :
                                        null
                                }
                            </ScrollView>
                            {
                                this.state.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }
                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize
                                    />
                                    :
                                    null
                            }
                            <HMModalSearch
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />

                            <HMModal
                                // style={{backgroundColor: Colors.transparent}}
                                // position={"center"}
                                // ref={"modal"}
                                // backdropPressToClose={true}
                                // coverScreen={true}
                                // swipeToClose={true}
                                // backButtonClose={true}
                                // isOpen={this.state.showModal}
                                // onClosed={() => this.setState({showModal: false})}

                                isVisible={this.state.showModal}
                                //visible={this.state.visibleModal}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() =>
                                    this.setState({showModal: false, typeModal: ""})
                                }
                                onBackButtonPress={() =>
                                    this.setState({showModal: false, typeModal: ""})
                                }

                                animationType="slide"
                                // transparent={true}
                            >

                                {

                                    this.state.showModal === "selectImage" ?
                                        <TouchableOpacity
                                            activeOpacity={1}
                                            style={{
                                                width: "100%",
                                                backgroundColor: Colors.white,
                                                padding: moderateScale(16),
                                                position: 'absolute',
                                                bottom: 0,
                                            }}>
                                            <View style={{
                                                width: '100%',
                                                flexDirection: 'row',
                                                marginBottom: moderateScale(6)
                                            }}>
                                                {
                                                    Platform.OS !== "web" ?
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                if (Platform.OS !== "web")
                                                                    ImagePicker.openCamera(typeExport.optional).then(image => {
                                                                        this.uploadFile(image);
                                                                    });

                                                            }}
                                                            style={{
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: '#A131C9',
                                                                width: moderateScale(48),
                                                                height: moderateScale(48),
                                                                borderRadius: moderateScale(24),
                                                                margin: moderateScale(5),
                                                                padding: moderateScale(8),
                                                                //  borderRadius: moderateScale(4),
                                                            }}>


                                                            <HMIcon type={"FontAwesome"} name={"camera"} style={{
                                                                width: moderateScale(22),
                                                                height: moderateScale(22),
                                                                //  borderRadius:moderateScale(20),
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: Colors.white,
                                                                //width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(21)
                                                            }}/>

                                                        </TouchableOpacity>
                                                        :
                                                        null
                                                }


                                                <View
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: moderateScale(48),
                                                        height: moderateScale(48),

                                                        //  borderRadius: moderateScale(4),
                                                    }}
                                                >
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            if (Platform.OS !== "web")
                                                                ImagePicker.openPicker({
                                                                    width: 1000,
                                                                    height: 1000,
                                                                    // crop: true,

                                                                    cropping: true
                                                                }).then(image => {
                                                                    // this.state.listImage.push(image)
                                                                    this.uploadFile(image);


                                                                });


                                                        }}
                                                        style={{
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: '#3AABDC',
                                                            padding: moderateScale(8),
                                                            margin: moderateScale(5),
                                                            width: moderateScale(48),
                                                            height: moderateScale(48),
                                                            borderRadius: moderateScale(24),
                                                        }}>

                                                        <HMIcon type={"FontAwesome"} name={"image"} style={{
                                                            width: moderateScale(22),
                                                            height: moderateScale(22),
                                                            //  borderRadius:moderateScale(20),
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.white,
                                                            //width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(21)
                                                        }}/>


                                                    </TouchableOpacity>
                                                    {
                                                        Platform.OS !== "web" ?
                                                            null
                                                            :
                                                            <label
                                                                onChange={this.fileSelect}

                                                                // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    bottom: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    opacity: .009
                                                                }}>
                                                                <input type="file" accept="image/*"/>

                                                            </label>
                                                    }
                                                </View>
                                            </View>
                                        </TouchableOpacity>
                                        :
                                        (
                                            this.state.showModal ?
                                                <TouchableOpacity
                                                    activeOpacity={1}
                                                    style={{
                                                        width: "96%",
                                                        backgroundColor: Colors.white,
                                                        padding: moderateScale(16)
                                                    }}>


                                                    <View style={{width: '100%'}}>
                                                        <HMTextView
                                                            type={"bold"}
                                                            noFont={false}
                                                            text={"متن مورد نظر را ویرایش نمایید"}
                                                            numberOfLines={1}
                                                            style={{
                                                                fontSize: moderateScale(15),
                                                                textAlign: 'right',
                                                                color: Colors.blackLight
                                                            }}/>
                                                        <View
                                                            style={{

                                                                paddingVertical: moderateScale(10),
                                                                marginHorizontal: moderateScale(6)
                                                            }}
                                                        >
                                                            <HMTextInput
                                                                value={this.state.comment}
                                                                number
                                                                onChangeText={text => {
                                                                    this.setState({comment: text})
                                                                }}

                                                                _height={moderateScale(100)}
                                                                //   keyboardType="numeric"
                                                                //  placeholder={i18n.t('constant.PlaceholderDesc')}
                                                                style={{
                                                                    // height:moderateScale(100),
                                                                    fontSize: moderateScale(14)
                                                                }} underlineColorAndroid="transparent"
                                                                styleInput={{height: moderateScale(80)}}

                                                                // textCenter={'center'}
                                                            />


                                                        </View>
                                                        <TouchableOpacity
                                                            style={{
                                                                backgroundColor: Colors.colorPrimary,
                                                                width: moderateScale(100),
                                                                height: moderateScale(40),
                                                                alignSelf: 'center',
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                marginTop: moderateScale(8),
                                                                borderRadius: moderateScale(6)
                                                                // borderRadius:moderateScale(2)
                                                            }}
                                                            onPress={() => {
                                                                // let {index, indexWork, item, itemWork} = this.state
                                                                // // this.getData()
                                                                //
                                                                // const formData = new FormData();
                                                                // formData.append('lang', i18n.locale);
                                                                // formData.append('record', item.id);
                                                                // formData.append('recordChild', itemWork.id);
                                                                // formData.append('_session', container.props.token);
                                                                // formData.append('_operation', typeExport._Shahrdar);
                                                                // // // formData.append('lang', params.lang);
                                                                // formData.append('mode', "EditAlbumComment");
                                                                // formData.append('comment', this.state.comment);
                                                                //
                                                                // this.setData(() => {
                                                                //     store.dispatch(serviceActionSetComment(this.state.comment, index, indexWork))
                                                                //
                                                                //     this.setState({showModal: false}
                                                                //         ,
                                                                //         () => {
                                                                //
                                                                //         }
                                                                //     )
                                                                // }, formData)


                                                            }}
                                                        >
                                                            <View style={{
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}>
                                                                <HMTextView type={"bold"}
                                                                    //   text={i18n.t('constant.signIn')}
                                                                            text={i18n.t('constant.Edit')}

                                                                            style={{
                                                                                color: "white",
                                                                                fontSize: moderateScale(13),
                                                                                //marginEnd: moderateScale(10)
                                                                            }}/>

                                                            </View>
                                                        </TouchableOpacity>
                                                    </View>


                                                </TouchableOpacity>
                                                :
                                                null
                                        )

                                }

                            </HMModal>
                        </View>


                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }


    setLike(item, index) {

        const formData = new FormData();
        formData.append('lang', i18n.locale);
        //  formData.append('record', item.id);

        let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? item.tracking_code : item.id;
        formData.append('record', id);
        formData.append('token', container.props.token);
        formData.append('_operation', typeExport._Registration);
        // // formData.append('lang', params.lang);
        formData.append('mode', "LikeTicket");


        store.dispatch(serviceActionSetLike(!item.like, index, {count_like: !item.like ? item.count_like + 1 : (item.count_like === 0 ? 0 : item.count_like - 1)}))


        this.requestServer((res) => {
            //  store.dispatch(serviceActionSetLike(!item.like, index,res))
        }, formData, false)
        // const some_array = [...this.state.list]
        //
        // some_array[index].like = !this.state.list[index].like
        //
        // this.setState({list: some_array}
        //     ,
        //     () => {
        //     }
        // )
    }

    getData() {


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        //  formData.append('record', this.state.item.id);
        //   formData.append('record', "191609");
        // formData.append('record', this.props.route.params.id);
        let params = this.props.route.params;
        let id = params.id ? params.id : ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? this.props.route.params.item.tracking_code : this.props.route.params.item.id;
        formData.append('record', id);
        formData.append(container.props.DataSplashScreen.TypeLogin == 1 ? "token" : '_session', this.props.route && this.props.route.params && this.props.route.params.token ? this.props.route.params.token : container.props.token);
        formData.append('_operation', container.props.DataSplashScreen.TypeLogin == 1 ? typeExport._Contacts : typeExport._Shahrdar);
        // // formData.append('lang', params.lang);
        formData.append('mode', "GetAlbumDetail");
        formData.append('isOperator', true);


        // store.dispatch(serviceActionSetLike(!item.like, index, {count_like: !item.like ? item.count_like + 1 : (item.count_like === 0 ? 0 : item.count_like - 1)}))
        //  if (store.getState().reducerSplashGetAllData.Connection) {
        //
        //      this.props.callService(typeExport._baseUrlSaina, paramss, typeExport.TypeGetGalleryServiceScreen, typeExport._POST, page, typeExport._Count, null)
        //
        //  } else {
        //      // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
        //      // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
        //      // store.dispatch(serviceActionListFilter(listFilter))
        //      // if (data != null)
        //      //     store.dispatch(serviceActionSuccess(data, 0))
        //      // else
        //      //     store.dispatch(serviceActionSuccess([], 0))
        //
        //      store.dispatch(serviceActionError('not connection', 1))
        //  }

        this.requestServer((res) => {
            this.setState({
                results: res
            })
            //   alert("djfhvj")
            //  store.dispatch(serviceActionSetLike(!item.like, index,res))
        }, formData)
    }

    requestServer(func, formData, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: container.props.DataSplashScreen.TypeLogin == 1 ? typeExport._baseUrlSainaShahrvand : typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    /*    HMAlert(
                            i18n.t('constant.message'),
                            data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                    }


                                },

                            ],
                            {cancelable: true}
                        )*/
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }
}

const delayTime = 300;
let container2 = null;

class DynamicContentSlide extends React.Component {
    constructor(props) {
        super(props);
        container2 = this;
    }

    state = {
        isButtonDisplayed: true,
        firstPress: true,
        lastTime: true,
        backClickCount: 0


    };

    render() {
        const {itemSwiper, indexSwiper, onPress, onPressLike} = this.props;
        const {isButtonDisplayed, firstPress, lastTime} = this.state;
        let timer = false;
        return (
            <TouchableOpacity
                activeOpacity={1}
                onPress={onPressLike}
                style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",

                    // marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#000',
                    //    borderTopRightRadius:moderateScale(8),
                    // borderTopEndRadius: moderateScale(12),
                    // borderTopStartRadius: moderateScale(8),

                    borderRadius: moderateScale(10),
                    overflow: "hidden"
                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={itemSwiper.file}
                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#ee7e0c",
                        //  borderTopRightRadius:moderateScale(8),
                        // borderTopEndRadius: moderateScale(12),
                        // borderTopStartRadius: moderateScale(8),
                        borderRadius: moderateScale(10),

                    }}
                    //  onLoad={this._onLoad}
                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                />

                {
                    itemSwiper.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }]}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.white,
                                        fontSize: moderateScale(13),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={itemSwiper.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>
        );
    }


}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailsGalleryServiceOperationScreen);
